import { createContext, useContext } from 'react'
import { BaseDateInput, BaseSelect, BaseTextInput, ElenchiManager, ITALY, isItaly, BaseGridLayout, formattaData, formattaIndirizzo, capitalizzaOgniParola, formattaLocalDate } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { LINK_FORM_ANAGRAFICA, LINK_FORM_INDIRIZZO } from 'configuration/link'
import ConfigManager from 'components/config/ConfigManager'
import LineaSeparatrice from 'components/ui/LineaSeparatrice'
import ListaLabelValoreSeparata from 'components/ui/ListaLabelValoreSeparata'
import Titoletto from 'components/ui/Titoletto'
import Testo from 'components/ui/Testo'
import useSchermoStretto from 'hook/useSchermoStretto'
import FormComune from './FormComune'
import FormPatente from './FormPatente'

const FormAnagraficaContext = createContext()

const CFG = LINK_FORM_ANAGRAFICA
const CFG_IND = LINK_FORM_INDIRIZZO

const NOMI = {
  COGNOME: 'cognome',
  NOME: 'nome',
  CODICEFISCALE: 'codicefiscale',
  TELEFONO: 'telefono',
  EMAIL: 'email',

  NASCITA_CAP: 'nascita.cap',
  NASCITA_COMUNE: 'nascita.comune',
  NASCITA_PROVINCIA: 'nascita.provincia',
  NASCITA_NAZIONE: 'nascita.nazione',
  NASCITA_DATA: 'nascita.data',

  IND_RESIDENZA_CAP: 'ind_residenza.cap',
  IND_RESIDENZA_COMUNE: 'ind_residenza.comune',
  IND_RESIDENZA_PROVINCIA: 'ind_residenza.provincia',
  IND_RESIDENZA_NAZIONE: 'ind_residenza.nazione',
  IND_RESIDENZA_TIPO: 'ind_residenza.tipo',
  IND_RESIDENZA_VIA: 'ind_residenza.via',
  IND_RESIDENZA_NUMERO: 'ind_residenza.numero',
}

FormAnagrafica.DEFAULT_VALUES = {
  cognome: '',
  nome: '',
  codicefiscale: '',
  telefono: '',
  email: '',
  nascita: {
    cap: '',
    comune: '',
    provincia: '',
    nazione: ITALY,
    data: null,
  },
  ind_residenza: {
    cap: '',
    comune: '',
    provincia: '',
    nazione: ITALY,
    tipo: '',
    via: '',
    numero: '',
  },
}

FormAnagrafica.trasformaValoriPerSalvataggio = function(valori) {
  const { nascita, ind_residenza, patente } = valori
  return {
    ...valori,
    nascita: {
      ...nascita,
      data: formattaLocalDate(nascita.data),
      nazione: isItaly(nascita.nazione) ? 'Italy' : nascita.nazione,
    },
    ind_residenza: {
      ...ind_residenza,
      nazione: isItaly(ind_residenza.nazione) ? 'Italy' : ind_residenza.nazione,
    },
    ...(patente && {
      patente: FormPatente.trasformaValoriPerSalvataggio(patente)
    })
  }
}

export default function FormAnagrafica(props) {
  const { prefissoNomi, titolo, sottotitolo } = props

  const { txt, el } = useContext(FormAnagraficaContext)

  const schermoStretto = useSchermoStretto()

  const propsGrid = (schermoStretto && { vertical: true, spacing: 0 })

  function n(nomeSenzaPrefisso) {
    return prefissoNomi ? `${prefissoNomi}.${nomeSenzaPrefisso}` : nomeSenzaPrefisso
  }

  return (
    <>
      {titolo && <Titoletto variant='h6'>{titolo}</Titoletto>}
      {sottotitolo && <Testo>{sottotitolo}</Testo>}
      <FormDatiAnagrafici txt={txt} propsGrid={propsGrid} n={n} />

      <LineaSeparatrice />

      <Titoletto variant='h6'>{txt(CFG.NASCITA_TITOLO)}</Titoletto>
      <FormNascita txt={txt} el={el} propsGrid={propsGrid} n={n} />

      <LineaSeparatrice />

      <Titoletto variant='h6'>{txt(CFG.RESIDENZA_TITOLO)}</Titoletto>
      <FormResidenza txt={txt} el={el} propsGrid={propsGrid} n={n} />
    </>
  )
}



function FormDatiAnagrafici(props) {
  const { txt, propsGrid, n } = props

  return (
    <BaseGridLayout {...propsGrid}>
      <BaseTextInput
        label={txt(CFG.COGNOME)} name={n(NOMI.COGNOME)}
        required
      />
      <BaseTextInput
        label={txt(CFG.NOME)} name={n(NOMI.NOME)}
        required
      />
      <BaseTextInput
        label={txt(CFG.CODICE_FISCALE)} name={n(NOMI.CODICEFISCALE)}
        required
      />
      <BaseTextInput
        label={txt(CFG.TELEFONO)} name={n(NOMI.TELEFONO)}
      />
      <BaseTextInput
        label={txt(CFG.EMAIL)} name={n(NOMI.EMAIL)}
      />
    </BaseGridLayout>
  )
}



function FormNascita(props) {
  const { txt, el, propsGrid, n } = props

  return (
    <BaseGridLayout {...propsGrid}>
      <FormComune
        nameCap={n(NOMI.NASCITA_CAP)}
        nameComune={n(NOMI.NASCITA_COMUNE)}
        nameProvincia={n(NOMI.NASCITA_PROVINCIA)}
        nameNazione={n(NOMI.NASCITA_NAZIONE)}
        labelComune={txt(CFG_IND.COMUNE)}
        labelComuneEstero={txt(CFG_IND.COMUNE_ESTERO)}
        labelNazione={txt(CFG_IND.NAZIONE)}
        labelInserisciCapComune={txt(CFG_IND.INSERISCI_CAP_COMUNE)}
        nazioni={el(ELENCHI.NAZIONI)}
        tipoRicercaNascita
        propsGrid={propsGrid}
      />
      <BaseDateInput
        label={txt(CFG.NASCITA_DATA)} name={n(NOMI.NASCITA_DATA)}
        required
        disabilitaToolbarCustom
        webComponentFix
      />
    </BaseGridLayout>
  )
}



function FormResidenza(props) {
  const { txt, el, propsGrid, n } = props

  return (
    <BaseGridLayout {...propsGrid}>
      <FormComune
        nameCap={n(NOMI.IND_RESIDENZA_CAP)}
        nameComune={n(NOMI.IND_RESIDENZA_COMUNE)}
        nameProvincia={n(NOMI.IND_RESIDENZA_PROVINCIA)}
        nameNazione={n(NOMI.IND_RESIDENZA_NAZIONE)}
        labelComune={txt(CFG_IND.COMUNE)}
        labelComuneEstero={txt(CFG_IND.COMUNE_ESTERO)}
        labelNazione={txt(CFG_IND.NAZIONE)}
        labelInserisciCapComune={txt(CFG_IND.INSERISCI_CAP_COMUNE)}
        nazioni={el(ELENCHI.NAZIONI)}
        propsGrid={propsGrid}
      />
      <BaseSelect
        label={txt(CFG_IND.TIPO_STRADA)} name={n(NOMI.IND_RESIDENZA_TIPO)}
        options={[{ value: '', label: '' }, ...el(ELENCHI.TIPI_INDIRIZZO)]}
        required
      />
      <BaseTextInput
        label={txt(CFG_IND.DENOMINAZIONE_STRADA)} name={n(NOMI.IND_RESIDENZA_VIA)}
        required
      />
      <BaseTextInput
        label={txt(CFG_IND.CIVICO)} name={n(NOMI.IND_RESIDENZA_NUMERO)}
        required
      />
    </BaseGridLayout>
  )
}



export function FormAnagraficaProvider(props) {
  const { children } = props

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_ANAGRAFICA, ELENCHI.CFG_LINK_FORM_INDIRIZZO]}
      render={({ txt }) =>
        <ElenchiManager
          elenchi={[ELENCHI.NAZIONI, ELENCHI.TIPI_INDIRIZZO]}
          render={el =>
            <FormAnagraficaContext.Provider value={{ txt, el }}>
              {children}
            </FormAnagraficaContext.Provider>
          }
        />
      }
    />
  )
}



export function RiassuntoAnagrafica(props) {
  const { anagrafica } = props
  const {
    cognome,
    nome,
    codicefiscale,
    telefono,
    email,
    nascita: {
      cap,
      comune,
      provincia,
      nazione,
      data,
    },
    ind_residenza,
  } = anagrafica

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_ANAGRAFICA, ELENCHI.CFG_LINK_FORM_INDIRIZZO]}
      render={({ val }) =>
        <ElenchiManager
          elenchi={[ELENCHI.NAZIONI, ELENCHI.TIPI_INDIRIZZO]}
          render={el => {
            const nazioni = el(ELENCHI.NAZIONI)

            let luogoNascita = ''
            if (nazione) {
              const italia = isItaly(nazione)
              const nazioneLabel = italia
                ? nazione
                : nazioni.find(({ value }) => value === nazione)?.label ?? nazione
              if (!comune && !cap && !provincia) {
                luogoNascita = italia ? '' : nazioneLabel
              } else {
                luogoNascita = italia ? `${comune} (${cap} ${provincia})` : `${comune}, ${nazioneLabel}`
              }
            }

            const residenzaFix = { ...ind_residenza, numeroCivico: ind_residenza.numero }
            let residenza = formattaIndirizzo(residenzaFix)
            if (residenza === 'Nessun indirizzo') residenza = ''

            return (
              <ListaLabelValoreSeparata
                lista={[
                  { label: val(CFG.COGNOME), valore: capitalizzaOgniParola(cognome) },
                  { label: val(CFG.NOME), valore: capitalizzaOgniParola(nome) },
                  { label: val(CFG.CODICE_FISCALE), valore: codicefiscale },
                  { label: val(CFG.NASCITA_TITOLO), valore: luogoNascita },
                  { label: val(CFG.NASCITA_DATA), valore: formattaData(data) },
                  { label: val(CFG.RESIDENZA_TITOLO), valore: residenza },
                  { label: val(CFG.TELEFONO), valore: telefono },
                  { label: val(CFG.EMAIL), valore: email },
                ]}
              />
            )
          }}
        />
      }
    />
  )
}